import styled from "styled-components";
import { Link } from "react-router-dom";

export const Container = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100vh;
	padding: 30px;
`;

export const Content = styled.div`
	background: #fff;
	display: flex;
	display: flex;
	flex-direction: column;
	padding: 50px 20px;
	justify-content: center;
	border-radius: 10px;

	h3 {
		text-align: center;
		font-weight: bold;
	}
`;

export const Message = styled.span`
	color: #3c3c3c;
	text-align: center;
	padding: 15px 0;
`;

export const Redirect = styled.button`
	margin-top: 5px;
	text-align: center;
`;
